import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { FC, useContext } from "react";
import { connect } from "react-redux";

export interface OrderToInvoiceLinksStyles {
    linksGridItem: GridItemProps;
    title: TypographyProps;
    titleGridItem: GridItemProps;
}

const styles: OrderToInvoiceLinksStyles = {
    linksGridItem: {
        width: [6, 4, 3, 2, 2],
    },
    titleGridItem: {
        width: [12, 12, 12, 1, 1],
    },
    title: {
        variant: "h6",
        as: "h2",
    },
};

export const linksStyles = styles;

const mapStateToProps = (state: ApplicationState) => {
    return {
        invoiceDetailsPageLink: getPageLinkByPageType(state, "InvoiceDetailsPage")?.url,
    };
};

interface OwnProps extends WidgetProps {}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const OrderToInvoiceLinks: FC<Props> = ({ invoiceDetailsPageLink }) => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.relatedInvoiceNumbers || order.relatedInvoiceNumbers.length < 1) {
        return null;
    }
    const orderLinks = [];
    for (const relatedInvoiceNumber of order.relatedInvoiceNumbers) {
        orderLinks.push(
            <GridItem {...styles.linksGridItem}>
                <Link href={`${invoiceDetailsPageLink}?invoiceNumber=${relatedInvoiceNumber}`}>
                    {relatedInvoiceNumber}
                </Link>
            </GridItem>,
        );
    }
    return (
        <section style={{ marginBottom: "10px" }}>
            <Typography {...styles.title}>{`${translate("Related Invoices")}`}</Typography>
            <GridContainer>{orderLinks}</GridContainer>
        </section>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderToInvoiceLinks),
    definition: {
        allowedContexts: ["OrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
